<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12">
          <iq-card>
            <template>
                <b-row>
                  <b-col lg="12" sm="12">
                    <b-row style="padding-left:5px">
                        <!-- <b-col xs="12" sm="12" md="2" class="text-right" style="margin-left: 82%; margin-top:8px">
                            <b-button variant="primary" @click="pdfExport">
                                {{  $t('globalTrans.export_pdf') }}
                            </b-button>
                        </b-col> -->
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('globalTrans.organization') }} : {{ getOrgList(exam.org_id) }}</span>
                        </b-col>
                         <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('ds_institute_management.institute_type') }} : {{ getInstituTypeName(exam.office_type_id) }}</span>
                        </b-col>
                         <b-col lg="6" sm="6">
                            <span class="text-dark" >{{ $t('ds_institute_management.institute_name') }} : {{ getInstituteName(exam.office_id) }}</span>
                        </b-col>
                         <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('child_configuration.committee_name') }} : {{ getCommitteeList(exam.committee_id) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('institute_manangement.formation_date') }} : {{ exam.formation_date | dateFormat }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('ds_institute_management.tenure_date') }} : {{ exam.tenure_date | dateFormat }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="12" sm="12">
                        <div>
                          <b-table-simple striped bordered small>
                              <b-tr class="bg-primary">
                                <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                <b-th>{{ $t('ds_institute_management.member_name') }}</b-th>
                                <b-th>{{ $t('ds_institute_management.designation') }}</b-th>
                                <b-th>{{ $t('ds_institute_management.contact_no') }}</b-th>
                                <b-th>{{ $t('ds_institute_management.nid') }}</b-th>
                                <b-th>{{ $t('ds_institute_management.email') }}</b-th>
                              </b-tr>
                              <b-tr v-for="(item, index) in exam.details" :key="index">
                                <b-td>
                                    {{ $n(index + 1) }}
                                </b-td>
                                <b-td>
                                    {{ currentLocale === 'en' ? item.member_name_en : item.member_name_bn }}
                                </b-td>
                                <b-td>
                                    {{ getDisignation(item.designation_id) }}
                                </b-td>
                                <b-td>
                                    {{ item.contact_no | mobileNumber }}
                                </b-td>
                                <b-td>
                                    {{ $n(item.nid, { useGrouping: false }) }}
                                </b-td>
                                <b-td>
                                    {{ item.email }}
                                </b-td>
                              </b-tr>
                          </b-table-simple>
                        </div>
                         <b-row style="padding-left:5px">
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('ds_institute_management.remarks') }} : {{ currentLocale === 'en' ? exam.remarks_en : exam.remarks_bn }}</span>
                        </b-col>
                        </b-row>
                        <div class="row">
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                            </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import ExportPdf from './export-routine-detail'
import { childServiceBaseUrl } from '@/config/api_config'
// import { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
export default {
  props: ['id'],
  created () {
    if (this.id) {
        const tmp = this.getExamInfoData()
        this.exam = tmp
    }
  },
  data () {
    return {
        exam: {
            fiscal_year_id: 0,
            org_id: 0,
            office_type_id: 0,
            office_id: 0,
            class_id: 0,
            exam_type_id: 0,
            details: []
        }
    }
  },
  computed: {
    localeLang () {
      return this.$i18n.locale
    },
     currentLocale () {
            return this.$i18n.locale
    }
  },
  methods: {
    getExamInfoData () {
        const tmpData = this.$store.state.list.find(item => item.id === this.id)
        return JSON.parse(JSON.stringify(tmpData))
    },
    getInstituteName (insId) {
      const obj = this.$store.state.commonObj.officeList.find(item => item.value === insId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
     getInstituTypeName (insId) {
      const obj = this.$store.state.commonObj.officeTypeList.find(item => item.value === insId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
     getOrgList (insId) {
      const obj = this.$store.state.commonObj.organizationProfileList.find(item => item.value === insId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
    getCommitteeList (courseId) {
        const obj = this.$store.state.DisabilitySchoolService.commonObj.committeeList.find(item => item.value === courseId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
     getDisignation (dId) {
        const obj = this.$store.state.DisabilitySchoolService.commonObj.designationList.find(item => item.value === dId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
    getFiscalYear (yearId) {
        const obj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === yearId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
    getExamType (typeId) {
        const obj = this.$store.state.DisabilitySchoolService.commonObj.examTypeList.find(item => item.value === typeId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
    getClassName (classId) {
        const obj = this.$store.state.DisabilitySchoolService.commonObj.classList.find(item => item.value === classId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
    pdfExport () {
        const reportTitle = this.$t('institute_manangement.committee_member') + ' ' + this.$t('globalTrans.details')
        ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', this.exam.org_id, reportTitle, this.exam, this)
    }
  }
}
</script>
